
import { mapState, mapGetters } from "vuex";
export default {
  data: () => ({
    showMenu: false
  }),
  computed: {
    ...mapState("restaurant", ["locationDetails"]),
    ...mapGetters("restaurant", ["getAllBrands"]),
    items() {
      return [
        {
          value: "copy-link",
          title: "Copy Link",
          subtitles: this.getAllBrands?.map((el) => ({
            label: el.name,
            id: el.id
          }))
        }
      ];
    }
  },
  methods: {
    handleClick(item, child) {
      if (item.value === "copy-link") {
        this.copyLink(child ? child.id : item.subtitles[0].id);
      }
    },
    copyLink(brandId) {
      const url = `${window.location.href.replace(this.$route.fullPath, "")}/${
        this.locationDetails.id
      }/${brandId}/menu`;
      this.copyToClipboard(url);
      this.$nuxt.$emit("show-toast", {
        text: "Link copied to clipboard",
        color: "success darken-2",
        icon: "done",
        flat: true
      });
      this.showMenu = false;
    }
  }
};
